import * as React from 'react';
import { generatePath, useParams } from 'react-router-dom';
import { useCloseModal } from '@core/router';

import { DeclarationTimeline } from '../containers';

export const DeclarationTimelinePage: React.FC = () => {
  const closeModal = useCloseModal();
  const { id } = useParams<{ id: string }>();

  const handleClose = React.useCallback(() => {
    closeModal(generatePath('/@next/declarations/:id', { id }));
  }, [closeModal, id]);

  return <DeclarationTimeline onClose={handleClose} id={id} />;
};
